import { usePostHogInit } from "@tokenterminal/core/analytics/usePostHogInit"

/**
 * Landing captures through the posthog-js singleton and has no flag hooks of
 * its own, so it needs the init and nothing else. Without it the pre-signup
 * half of the funnel is invisible — every visitor arrives here first.
 */
export function PostHogInit() {
  usePostHogInit({
    apiKey: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    apiHost: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
  })

  return null
}
